<!-- Button "getSchema" -->
<button (click)="getSchema()" class="rounded bg-blue-500 px-4 py-2 text-white hover:bg-blue-600 focus:outline-none">Get Schema</button>

<!-- Button "getDataPackage"-->
<button (click)="getDataPackage()" class="rounded bg-blue-500 px-4 py-2 text-white hover:bg-blue-600 focus:outline-none">
  Get Data Package
</button>

<button (click)="loadDataPackage()" class="rounded bg-blue-500 px-4 py-2 text-white hover:bg-blue-600 focus:outline-none">
  Parse Data Package
</button>

<!-- Button "getDataInstance -->
<input
  type="text"
  [(ngModel)]="dataInstanceIdInput"
  class="rounded border border-gray-300 px-4 py-2 focus:outline-none"
  placeholder="Data Instance ID"
/>
<button
  (click)="getDataInstance(dataInstanceIdInput())"
  class="rounded bg-blue-500 px-4 py-2 text-white hover:bg-blue-600 focus:outline-none"
  [disabled]="!dataInstanceIdInput"
>
  Get Data Instance
</button>
